import { EvolutionForm, FormValues } from 'src/app/shared/models/evolutionForm';
import { mapFormData } from './form-mapper';
import { buildFields, isEmptyValue } from './form-fields';

// Follows the same step path as the wizard and checks that every required field has an answer.
export function isFormComplete(form: EvolutionForm, values: FormValues): boolean {
    const sections = mapFormData(form).formSections;
    const visited = new Set<number>();
    let step = 0;

    while (step < sections.length && !visited.has(step)) {
        visited.add(step);
        const fields = buildFields(sections[step].formData);

        if (fields.some(field => field.required && isEmptyValue(values[field.key]?.value))) return false;

        const isLast = sections[step].final === 1 || step === sections.length - 1;
        if (isLast) return true;

        const branch = fields.find(field => field.goTo?.length);
        const index = branch ? branch.options.findIndex(option => option.value === values[branch.key]?.value) : -1;
        const target = branch ? branch.goTo[index] : undefined;
        step = Number.isInteger(target) ? target - 1 : step + 1;
    }
    return false;
}
